import { render, staticRenderFns } from "./FarmBasicItems.vue?vue&type=template&id=368f9aca&"
import script from "./FarmBasicItems.vue?vue&type=script&lang=js&"
export * from "./FarmBasicItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports